module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Light.a60a2f5c.ttf";